import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function SearchResults() {
  const [professionals, setProfessionals] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    
    const locationName = params.get("location") || "";
    const category = params.get("category") || "";

    const apiUrl = `https://w3connect.in.net/InteriorMart/api/search.php?location=${encodeURIComponent(locationName)}&category=${encodeURIComponent(category)}`;
    console.log("API URL:", apiUrl);

    fetch(apiUrl)
      .then((response) => {
        console.log("Status:", response.status);

        if (!response.ok) {
          throw new Error("HTTP Error : " + response.status);
        }

        return response.json();
      })
      .then((data) => {
        console.log("API Data:", data);
        setProfessionals(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Fetch Error:", error);
        setLoading(false);
      });
  }, [location.search]);

  if (loading) {
    return (
      <div style={{ padding: "150px 50px" }}>
        <h2>Loading...</h2>
      </div>
    );
  }

  return (
    <div style={{ padding: "140px 50px" }}>
      <h1>Search Results</h1>

      <h3>Total Results : {professionals.length}</h3>

      {professionals.length === 0 ? (
        <h2>No Results Found</h2>
      ) : (
        professionals.map((item) => (
          <div
            key={item.id}
            style={{
              border: "1px solid #ddd",
              padding: "20px",
              marginBottom: "20px",
              borderRadius: "10px",
            }}
          >
            <h2>{item.name}</h2>

            <p>
              <b>Category :</b> {item.category}
            </p>

            <p>
              <b>Location :</b> {item.location}
            </p>

            <p>
              <b>Experience :</b> {item.experience}
            </p>

            <p>
              <b>Phone :</b> {item.phone}
            </p>

            <p>
              <b>Email :</b> {item.email}
            </p>

            <p>{item.description}</p>
          </div>
        ))
      )}
    </div>
  );
}

export default SearchResults;